import {PriceMapper} from "@app/core/shared/infrastructure/mappers/price.mapper";
import {MyOrderItem} from "../../domain/dtos/my-order-item";

export class OrderDetailItemMapper {
    static deserialize(param: any): MyOrderItem {
        return {
            name: param.name,
            quantity: param.quantity,
            image: param.imageUrl,
            code: param.code,
            price: PriceMapper.deserialize(param.priceBox),
            units: param.unitsBox,
            unitPrice: PriceMapper.deserialize(param.priceUnit),
            palletPrice: param.paletPrice,
            promotionCode: param.promotionCode
        }
    }
}
